/* eslint-disable */
import PropTypes from 'prop-types';
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_NEW,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
} from '../../Constants/Order/Order.constants';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import propsActionCreatorsToPropTypes from '../../Support/Props/ActionCreatorKey/PropsActionCreatorsToPropTypes.support';

const OrderStatusGroupPropTypes = {
  /**
   * The actions to be used by this component
   */
  actions: PropTypes.shape({
    ...propsActionCreatorsToPropTypes(filtersActionCreators),
  }).isRequired,

  /**
   * The checkedItems
   */
  checkedItems: PropTypes.arrayOf(
    PropTypes.oneOf([
      ORDER_STATUS_TO_BE_CONFIRMED,
      ORDER_STATUS_CONFIRMED,
      ORDER_STATUS_DELIVERING,
      ORDER_STATUS_ON_HOLD,
      ORDER_STATUS_COMPLETED,
      ORDER_STATUS_CANCELLED,
      ORDER_STATUS_NEW,
    ]),
  ),

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderStatusGroupPropTypes;
